document.addEventListener("DOMContentLoaded", function () {
  const slickControls = document.querySelector(".qld__slick-controls");
  var parentContainer = document.querySelector('.slick-list');
  var prevButton = document.querySelector('.qld__slick-prev');
  var nextButton = document.querySelector('.qld__slick-next');
  var liveRegion = document.getElementById('aria-live-region');
  var cardsPerSlide = 4;
  var currentIndex = 0;

  if (parentContainer) {
      var newsItems = parentContainer.querySelectorAll('.qld__card__title');
      var totalSlides = Math.ceil(newsItems.length / cardsPerSlide);

      if (slickControls) {
          updateAriaSelected();

          slickControls.addEventListener("afterChange", function (event, slick, currentSlide) {
              currentIndex = currentSlide;
              updateAriaSelected();
          });

          function updateAriaSelected() {
              const dots = document.querySelectorAll(".slick-dots button");
              dots.forEach((dot, index) => {
                  dot.setAttribute("aria-selected", "false");

                  dot.addEventListener("click", function () {
                      currentIndex = index;
                      updateLiveRegion(liveRegion, `Showing News items ${index + 1}: ${getVisibleCardTitles(index)}`);
                  });

                  // Listen for keyboard navigation
                  dot.addEventListener("keydown", function (event) {
                      if (event.key === "Enter" || event.key === " ") {
                          currentIndex = index;
                          updateLiveRegion(liveRegion, `Showing News items ${index + 1}: ${getVisibleCardTitles(index)}`);
                      }
                  });
              });

              const activeDot = document.querySelector(".slick-dots .slick-active button");
              if (activeDot) {
                  activeDot.setAttribute("aria-selected", "true");
              }
          }
      }

      if (prevButton && nextButton && liveRegion) {
          prevButton.addEventListener('click', function () {
              if (currentIndex > 0) {
                  currentIndex--;
                  updateLiveRegion(liveRegion, `Moving to Section number ${currentIndex + 1}`);
              }
          });

          nextButton.addEventListener('click', function () {
              if (currentIndex < totalSlides - 1) {
                  currentIndex++;
                  updateLiveRegion(liveRegion, `Moving to Section number ${currentIndex + 1}`);
              }
          });

          // Handle keyboard navigation for arrow keys
          document.addEventListener("keydown", function (event) {
              if (document.activeElement.classList.contains("slick-arrow")) {
                  if (event.key === "ArrowLeft" && currentIndex > 0) {
                      currentIndex--;
                      updateLiveRegion(liveRegion, `Moving to Section number ${currentIndex + 1}`);
                  }
                  if (event.key === "ArrowRight" && currentIndex < totalSlides - 1) {
                      currentIndex++;
                      updateLiveRegion(liveRegion, `Moving to Section number ${currentIndex + 1}`);
                  }
              }
          });
      }

      function updateLiveRegion(liveRegion, message) {
          setTimeout(function () {
              liveRegion.innerHTML = message;
              console.log(`Live region updated: ${message}`);
          }, 400);
      }

      function getVisibleCardTitles(slideIndex) {
          let start = slideIndex * cardsPerSlide;
          let end = Math.min(start + cardsPerSlide, newsItems.length);
          let titles = [];

          for (let i = start; i < end; i++) {
              titles.push(newsItems[i].querySelector('a').textContent.trim());
          }

          return titles.join(', ');
      }
  } else {
      console.error("Parent container with class 'slick-list' not found.");
  }
});
